import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './core/serviceWorker';
import './index.scss';
import LogRocket from 'logrocket';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { AMPLITUDE_API_KEY } from './keys';

const tagManagerArgs = {
  gtmId: 'GTM-MQQ6MJ9',
};

ReactDOM.render(<App />, document.getElementById('root'));
// LogRocket.init('zqebrc/airbtics');
hotjar.initialize(1926311, 6);
TagManager.initialize(tagManagerArgs);

amplitude.init(AMPLITUDE_API_KEY, {
  autocapture: false,
  defaultTracking: {
    sessions: true,
  },
});

// Create and Install Session Replay Plugin
const sessionReplayTracking = sessionReplayPlugin({
  sampleRate: 1,
});
amplitude.add(sessionReplayTracking);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
